module.exports = __webpack_public_path__ + "img/logo-nav.0fd9ef89.png";